import React, { useState, useEffect, useMemo } from 'react';
import Layout from '@/common/Layout';
import styles from '@/common/Layout/index.module.less';
import {
  Card,
  Form,
  Row,
  Col,
  Select,
  Input,
  Space,
  Image,
  message,
  Alert
} from 'antd';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import {
  getAllMaterialslist,
  getAllCodes,
  createReturnMaterials,
  getAllProductsList,
  updateStatus,
  printContainerlabel,
  generateMRRReceipt
} from '../../redux/slice';
import moment from 'moment';
import truck from '../images/truck-delivery-done.gif';
import { history } from 'app/history';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import { useLocation } from 'react-router-dom';

const { TextArea } = Input;

const CreateReturnQty = ({ loading }) => {
  const [form] = Form.useForm();

  const { allMaterials, getAllMaterilLoading } = useSelector(
    (state) => state.returns
  );

  const [materials, setMaterials] = useState([
    {
      material_id: '',
      material_name: '',
      batch_detail_id: '',
      returned_qty: '',
      uom: '',
      product_batch_id: '',
      product_batch_number: '',
      mrr_container_count: '',
      returned_containers: [], // Array to hold container rows
      showContainerInput: false // Flag to show/hide container input section
    }
  ]);
  // const [editReturn, setEditReturn] = useState([]);

  const { user } = getLoggedInUser();
  const { SuperadminProddata } = getRoles('Production');
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);

  const [search, setSearch] = useState('');
  const [codes, setCodes] = useState([]);
  const [batches, setBatches] = useState([]);
  const [truckShow, setTruckShow] = useState(false);
  const [comments, setComments] = useState('');
  const [qAComments, setQAComments] = useState('');
  const [whComments, setWHComments] = useState('');
  const [status, setStatus] = useState('');
  const [productId, setProductId] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const [prodBatches, setProdBatches] = useState([]);
  const [inhouseBatches, setInhouseBatches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [printingId, setPrintingId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    handleGetAllMaterialsList();
    searchParams.get('id') || searchParams.get('uuid')
      ? handleGetMaterialById()
      : '';
  }, [search]);

  const handleGetAllMaterialsList = () => {
    let payload = { search };
    dispatch(getAllProductsList(payload));
  };

  const convertData = (inputData) => {
    // Extract all dispensing_request_ids
    const dispensingRequestIds = inputData.map(
      (item) => item.dispensing_request_id
    );
    const dispensingProductBatches = inputData.map(
      (item) => item.product_batch_number
    );

    // Get common fields from first item
    const firstItem = inputData[0];
    const productName = firstItem.product_name;
    const bmrNumber = firstItem.bmr_number;
    const returnedDate = firstItem.returned_date;

    // Process returned material items
    const returnedMaterialItems = inputData.flatMap((item) => {
      return item.returned_material_codes.map((materialCode) => {
        // Process containers
        const returnedContainers = materialCode.mrr_containers.map(
          (container, index) => ({
            container_count:
              container?.container_count ||
              `${index + 1} of ${materialCode.mrr_container_count}`,
            container_qty: container.container_qty.toString(),
            mrr_container_id: container?.id,
            is_print: container?.is_print
          })
        );

        return {
          id: materialCode?.id,
          material_id: materialCode.material_id,
          material_name: materialCode.material_name,
          batch_detail_id: materialCode.batch_detail_id,
          returned_qty: materialCode.returned_qty,
          uom: materialCode.uom,
          product_batch_id: item.product_batch_number,
          material_code: materialCode.material_code,
          inhouse_batch_no: materialCode.inhouse_batch_no,
          mrr_container_count: materialCode.mrr_container_count.toString(),
          container_number: `1 of ${materialCode.mrr_container_count}`,
          container_qty: returnedContainers[0]?.container_qty || '0',
          showContainerInput: true,
          returned_containers: returnedContainers
        };
      });
    });

    return {
      dispensing_request_id: dispensingRequestIds,
      dispensingProductBatches: dispensingProductBatches,
      product_name: productName,
      bmp_bpr_number: bmrNumber,
      returned_date: returnedDate,
      returned_material_items: returnedMaterialItems
    };
  };

  // // Usage
  // const inputData = [
  //   /* your JSON data here */
  // ];
  // const result12 = convertData(inputData);
  // console.log(JSON.stringify(result12, null, 2));

  const handleGetMaterialById = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('uuid');
    const id = urlParams.get('id');

    // Construct payload based on what parameter exists
    const payload = uuid ? { uuid: uuid } : { id: id };
    dispatch(getAllMaterialslist(payload)).then((response) => {
      if (response?.payload?.success) {
        if (uuid) {
          const result12 = convertData(response?.payload?.data);
          form.setFieldsValue({
            dispensing_request_id: result12?.dispensingProductBatches,
            product_name: result12?.product_name,
            bmp_bpr_number: result12?.bmp_bpr_number,
            returned_date: result12?.returned_date
          });
          setStatus(result12?.status);
          setQAComments(result12?.QA_comments);
          setWHComments(result12?.WH_comments);
          setMaterials(result12?.returned_material_items);
          setProductId(result12?.dispensing_request_id);
        } else {
          form.setFieldsValue({
            dispensing_request_id: searchParams.get('id')
              ? response?.payload?.data?.product_batch_number
              : response?.payload?.data?.dispensing_request_id,
            product_name: response?.payload?.data?.product_name,
            bmp_bpr_number: response?.payload?.data?.bmr_number,
            returned_date: response?.payload?.data?.returned_date
          });
          setStatus(response?.payload?.data?.status);
          setQAComments(response?.payload?.data?.QA_comments);
          setWHComments(response?.payload?.data?.WH_comments);
          setMaterials(
            response?.payload?.data.returned_material_codes.map(
              (materialCode) => {
                // Process containers
                const returnedContainers = materialCode.mrr_containers.map(
                  (container, index) => ({
                    container_count:
                      container?.container_count ||
                      `${index + 1} of ${materialCode.mrr_container_count}`,
                    container_qty: container.container_qty.toString(),
                    mrr_container_id: container?.id,
                    is_print: container?.is_print
                  })
                );

                return {
                  id: materialCode?.id,
                  showContainerInput: true,
                  material_id: materialCode.material_id,
                  material_name: materialCode.material_name,
                  batch_detail_id: materialCode.batch_detail_id,
                  returned_qty: materialCode.returned_qty,
                  uom: materialCode.uom,
                  product_batch_id:
                    response?.payload?.data?.product_batch_number,
                  material_code: materialCode.material_code,
                  inhouse_batch_no: materialCode.inhouse_batch_no,
                  mrr_container_count:
                    materialCode.mrr_container_count.toString(),
                  container_number: `1 of ${materialCode.mrr_container_count}`,
                  container_qty: returnedContainers[0]?.container_qty || '0',
                  // showContainerInput: true,
                  returned_containers: returnedContainers
                };
              }
            ) || []
          );

          setProductId(response?.payload?.data?.dispensing_request_id);
        }
      }
    });
  };

  const firstSelectedProductId = useMemo(() => {
    if (selectedValues.length === 0) return null;

    const firstItem = allMaterials?.find(
      (item) => item.id === selectedValues[0]
    );
    return firstItem?.product_id || null;
  }, [selectedValues, allMaterials]);

  const filteredMaterials = useMemo(() => {
    if (!allMaterials) return [];

    if (selectedValues.length === 0) return allMaterials;

    return allMaterials.filter(
      (item) => item.product_id === firstSelectedProductId
    );
  }, [allMaterials, firstSelectedProductId, selectedValues.length]);

  // Same "(Process › SubProcess)" suffix used by the top multi-select, derived from
  // an operation's dispensing-request id. Lets the bottom "Product batch" dropdown
  // disambiguate two operations of the SAME batch (e.g. Packing › Addition vs
  // Packing › Packing). Display-only — the option value stays the dispense_req_id.
  // Falls back to no suffix if the operation can't be matched (keeps prior behaviour).
  const getOperationSuffix = (dispenseReqId) => {
    const op = allMaterials?.find((m) => m.id == dispenseReqId);
    const dp = op?.prod_label_process_master?.process_label_name;
    const dsp = op?.prod_label_sub_process?.sub_process_name;
    return dp && dsp ? ` (${dp} › ${dsp})` : dp ? ` (${dp})` : '';
  };

  const handleChangeMaterial = (values) => {
    setSelectedValues(values);
    // if (values.length < selectedValues.length) {
    //   // Filter out materials associated with removed batches
    //   const updatedMaterials = materials.filter((material) => {
    //     // Keep materials that don't have a product_batch_id or whose batch is still selected
    //     if (!material.product_batch_id) return true;

    //     // Check if the material's batch is still in the selected values
    //     return values.includes(material.product_batch_id);
    //   });

    //   // If no materials left, reset to initial state
    //   if (updatedMaterials.length === 0) {
    //     setMaterials([
    //       {
    //         material_id: '',
    //         material_name: '',
    //         batch_detail_id: '',
    //         returned_qty: '',
    //         uom: '',
    //         product_batch_id: '',
    //         product_batch_number: '',
    //         mrr_container_count: '',
    //         returned_containers: [],
    //         showContainerInput: false
    //       }
    //     ]);
    //   } else {
    //     setMaterials(updatedMaterials);
    //   }
    // }
    setMaterials([
      {
        material_id: '',
        material_name: '',
        batch_detail_id: '',
        returned_qty: '',
        uom: '',
        product_batch_id: '',
        product_batch_number: '',
        mrr_container_count: '',
        returned_containers: [],
        showContainerInput: false
      }
    ]);
    onChange(values);
  };

  const addMaterials = () => {
    setMaterials([
      ...materials,
      {
        material_id: '',
        material_name: '',
        batch_detail_id: '',
        returned_qty: '',
        uom: '',
        mrr_container_count: '',
        returned_containers: [],
        showContainerInput: false
      }
    ]);
  };

  const removeMaterials = (index) => {
    const list = [...materials];
    list.splice(index, 1);
    setMaterials(list);
  };

  const onSearch = (value) => {
    setSearch(value);
  };

  const onChange = (e) => {
    setSelectedValues(e);
    const lastSelectedId = e[e.length - 1];
    const material = allMaterials.filter(
      (MaterialsList) => MaterialsList.id === lastSelectedId
    );
    form.setFieldsValue({ product_name: material[0]?.product_detail?.name });
    form.setFieldsValue({
      bmp_bpr_number: material[0]?.bmr_number
    });
    form.setFieldsValue({ returned_date: moment().format('YYYY-MM-DD') });

    const payload = { dispensing_request_id: e };
    dispatch(getAllCodes(payload)).then((response) => {
      if (response?.payload?.success) {
        setCodes(response?.payload?.data);
      }
    });
  };

  const grouped = codes.reduce((acc, item) => {
    const code = item.materials[0].code;

    if (!acc[code]) {
      acc[code] = {
        ...item,
        dispensing_request_ids: [item.dispensing_request_id],
        product_batch_numbers: [
          {
            batch_number: item.product_batch_number,
            dispense_req_id: item?.dispensing_request_id
          }
        ],
        batch_details_ids: [...item.batch_details_ids]
      };
      delete acc[code].dispensing_request_id;
      delete acc[code].product_batch_number;
    } else {
      if (
        !acc[code].dispensing_request_ids.includes(item.dispensing_request_id)
      ) {
        acc[code].dispensing_request_ids.push(item.dispensing_request_id);
      }

      // Check if this combination already exists
      const batchExists = acc[code].product_batch_numbers.some(
        (batch) =>
          batch.batch_number === item.product_batch_number &&
          batch.dispense_req_id === item.dispensing_request_id
      );

      if (!batchExists) {
        acc[code].product_batch_numbers.push({
          batch_number: item.product_batch_number,
          dispense_req_id: item?.dispensing_request_id
        });
      }

      item.batch_details_ids.forEach((id) => {
        if (!acc[code].batch_details_ids.includes(id)) {
          acc[code].batch_details_ids.push(id);
        }
      });
    }

    return acc;
  }, {});
  // const grouped = codes.reduce((acc, item) => {
  //   const code = item.materials[0].code;
  //   console.log(codes, 'item.product_batch_number');
  //   if (!acc[code]) {
  //     acc[code] = {
  //       ...item,
  //       dispensing_request_ids: [item.dispensing_request_id],
  //       product_batch_numbers: [
  //         {
  //           batch_number: item.product_batch_number,
  //           dispense_req_id: item?.dispensing_request_id
  //         }
  //       ],
  //       batch_details_ids: [...item.batch_details_ids]
  //     };
  //     delete acc[code].dispensing_request_id;
  //     delete acc[code].product_batch_number;
  //   } else {
  //     if (
  //       !acc[code].dispensing_request_ids.includes(item.dispensing_request_id)
  //     ) {
  //       acc[code].dispensing_request_ids.push(item.dispensing_request_id);
  //     }
  //     if (
  //       !acc[code].product_batch_numbers.includes(item.product_batch_number)
  //     ) {
  //       acc[code].product_batch_numbers.push(item.product_batch_number);
  //     }
  //     item.batch_details_ids.forEach((id) => {
  //       if (!acc[code].batch_details_ids.includes(id)) {
  //         acc[code].batch_details_ids.push(id);
  //       }
  //     });
  //   }

  //   return acc;
  // }, {});

  const result = Object.values(grouped);
  const handleChange = (e, index, type) => {
    const mat_codes =
      type == 'material_id'
        ? result.filter((code) => code.materials?.[0]?.id === e.id)
        : type == 'batch_detail_id'
        ? batches.filter((code) => code.id == e)
        : '';
    let product_batch_main_id = '';
    if (type == 'product_batch_id') {
      product_batch_main_id = filteredMaterials?.filter(
        (data) => data?.id == e
      );
    }
    const list = [...materials];
    list[index][type] =
      type == 'material_id'
        ? e.id
        : type == 'product_batch_id'
        ? product_batch_main_id?.[0]?.id
        : e;

    const prod_batch_codes =
      type == 'product_batch_id'
        ? codes.filter(
            (code) =>
              code.material_id === list[index]['material_id'] &&
              code.dispensing_request_id === e
          )
        : [];
    setInhouseBatches(prod_batch_codes);

    if (type === 'product_batch_id') {
      // const tot_qty = prod_batch_codes?.[0]?.total_net_weight?.filter(
      //   (data) => data?.batch_id === product_batch_main_id?.[0]?.id
      // );
      // console.log(tot_qty, 'tttt');
      list[index]['inhouse_batch_no'] = '';
      // list[index]['total_qty'] = tot_qty?.[0]?.net_weight;
      setMaterials(list);
    }

    type == 'material_id'
      ? (list[index]['material_code'] = mat_codes?.[0]?.materials?.[0]?.code)
      : '';
    type == 'material_id'
      ? (list[index]['material_name'] = mat_codes?.[0]?.materials?.[0]?.name)
      : '';
    type == 'material_id'
      ? (list[index]['uom'] = mat_codes?.[0]?.materials?.[0]?.uom)
      : '';
    type == 'material_id'
      ? (list[index]['product_batch_id'] =
          prod_batch_codes?.[0]?.dispensing_request_id)
      : '';
    type == 'material_id'
      ? (list[index]['product_batch_number'] =
          product_batch_main_id?.[0]?.product_batch_number)
      : '';

    if (type == 'material_id') {
      setProdBatches(mat_codes);
    }

    setBatches(
      prod_batch_codes?.[0]?.materials?.[0]?.batch_details?.filter((batch) =>
        prod_batch_codes?.[0]?.batch_details_ids?.includes(batch?.id)
      ) || []
    );

    if (type == 'batch_detail_id') {
      const tot_qty = inhouseBatches?.[0]?.total_net_weight?.filter(
        (data) => data?.batch_id === mat_codes?.[0]?.id
      );
      list[index]['inhouse_batch_no'] = mat_codes?.[0]?.inhouse_batch_number;
      list[index]['returned_qty'] = tot_qty?.[0]?.net_weight;
      list[index]['total_qty'] = tot_qty?.[0]?.net_weight;
    }

    setMaterials(list);
  };

  const calculateTotalContainerQty = (containers) => {
    return containers.reduce((sum, container) => {
      return sum + (parseFloat(container.container_qty) || 0);
    }, 0);
  };
  // Handle container input changes
  const handleContainerChange = (
    materialIndex,
    containerIndex,
    field,
    value,
    containerCount
  ) => {
    if (searchParams?.get('uuid')) {
      const list = [...materials];
      if (!list[materialIndex].returned_containers) {
        list[materialIndex].returned_containers = [];
      }
      if (!list[materialIndex].returned_containers[containerIndex]) {
        list[materialIndex].returned_containers[containerIndex] = {
          container_count: '',
          container_qty: ''
        };
      }
      list[materialIndex].returned_containers[containerIndex]['container_qty'] =
        value;
      list[materialIndex].returned_containers[containerIndex][
        'container_count'
      ] = `Container ${containerIndex + 1} of ${containerCount}`;
      const totalContainerQty = calculateTotalContainerQty(
        list[materialIndex].returned_containers
      );
      const returnedQty = parseFloat(list[materialIndex].returned_qty) || 0;
      if (parseFloat(totalContainerQty) > returnedQty) {
        // Show error message
        message.error(
          `Sum of container quantities (${totalContainerQty.toFixed(
            2
          )}) cannot exceed Total Qty (${returnedQty})`
        );
        // Revert the change
        list[materialIndex].returned_containers[containerIndex][
          'container_qty'
        ] = '';
        setMaterials(list);
        return;
      }
      setMaterials(list);
    }
    if (searchParams?.get('id')) {
      const list = [...materials];
      // list[materialIndex].returned_containers[containerIndex][
      //   'mrr_container_id'
      // ] = list[materialIndex].returned_containers[containerIndex].id;
      list[materialIndex].returned_containers[containerIndex]['container_qty'] =
        value;
      list[materialIndex].returned_containers[containerIndex][
        'container_count'
      ] = `Container ${containerIndex + 1} of ${containerCount}`;
      const totalContainerQty = calculateTotalContainerQty(
        list[materialIndex].returned_containers
      );
      const returnedQty = parseFloat(list[materialIndex].returned_qty) || 0;
      if (parseFloat(totalContainerQty) > returnedQty) {
        // Show error message
        message.error(
          `Sum of container quantities (${totalContainerQty.toFixed(
            2
          )}) cannot exceed Total Qty (${returnedQty})`
        );
        // Revert the change
        list[materialIndex].returned_containers[containerIndex][
          'container_qty'
        ] = '';
        setMaterials(list);
        return;
      }
      setMaterials(list);
    } else {
      const list = [...materials];
      // list[materialIndex].returned_containers[containerIndex][
      //   'mrr_container_id'
      // ] = list[materialIndex].returned_containers[containerIndex].id;
      list[materialIndex].returned_containers[containerIndex]['container_qty'] =
        value;
      list[materialIndex].returned_containers[containerIndex][
        'container_count'
      ] = `Container ${containerIndex + 1} of ${containerCount}`;
      const totalContainerQty = calculateTotalContainerQty(
        list[materialIndex].returned_containers
      );
      const returnedQty = parseFloat(list[materialIndex].returned_qty) || 0;
      if (parseFloat(totalContainerQty) > returnedQty) {
        // Show error message
        message.error(
          `Sum of container quantities (${totalContainerQty.toFixed(
            2
          )}) cannot exceed Total Qty (${returnedQty})`
        );
        // Revert the change
        list[materialIndex].returned_containers[containerIndex][
          'container_qty'
        ] = '';
        setMaterials(list);
        return;
      }
      setMaterials(list);
    }
  };

  const canEnableUpdateButton = () => {
    // For each material, validate it has all required data
    return materials.every((material) => {
      // Material must have material_id, returned_qty, and mrr_container_count
      if (
        !material.material_id ||
        !material.returned_qty ||
        !material.mrr_container_count
      ) {
        return false;
      }

      const containers = searchParams?.get('uuid')
        ? material.returned_containers || []
        : material.returned_containers || [];
      const containerCount = parseInt(material.mrr_container_count) || 0;
      const returnedQty = parseFloat(material.returned_qty) || 0;

      // Must have containers
      if (containers.length === 0) {
        return false;
      }

      // All containers must have valid data (non-empty and non-negative)
      const allContainersValid = containers.every(
        (container) =>
          container.container_count &&
          container.container_qty !== '' &&
          container.container_qty !== null &&
          container.container_qty !== undefined &&
          parseFloat(container.container_qty) >= 0
      );

      if (!allContainersValid) {
        return false;
      }

      // Number of filled containers should match mrr_container_count
      if (containers.length !== containerCount) {
        return false;
      }

      // Calculate sum of container quantities
      const totalContainerQty = containers.reduce((sum, container) => {
        return sum + (parseFloat(container.container_qty) || 0);
      }, 0);
      // Sum of container quantities must equal returned quantity
      // Using toFixed to handle floating point precision issues
      return totalContainerQty.toFixed(2) === returnedQty.toFixed(2);
    });
  };

  const canEnableCreateButton = () => {
    // If no product batches selected, disable button
    if (!selectedValues || selectedValues.length === 0) {
      return false;
    }

    // Every material row must be fully valid — no incomplete rows allowed
    const allMaterialsValid = materials.every((material) => {
      // Material must have material_id, returned_qty, and product_batch_id
      if (
        !material.material_id ||
        !material.returned_qty ||
        !material.product_batch_id
      ) {
        return false;
      }

      const containers = material.returned_containers || [];
      const containerCount = parseInt(material.mrr_container_count) || 0;

      // Must have containers and container count > 0
      if (containers.length === 0 || containerCount <= 0) {
        return false;
      }

      // Number of containers must match declared count
      if (containers.length !== containerCount) {
        return false;
      }

      // Check all containers have valid data (allow 0 or positive values)
      const allContainersValid = containers.every(
        (container) =>
          container.container_count &&
          container.container_qty !== '' &&
          container.container_qty !== null &&
          container.container_qty !== undefined &&
          parseFloat(container.container_qty) >= 0
      );

      if (!allContainersValid) {
        return false;
      }

      // Calculate sum of container quantities
      const totalContainerQty = containers.reduce((sum, container) => {
        return sum + (parseFloat(container.container_qty) || 0);
      }, 0);

      const returnedQty = parseFloat(material.returned_qty) || 0;

      // Sum of container quantities must equal returned quantity
      // Using toFixed to handle floating point precision issues
      return totalContainerQty.toFixed(2) === returnedQty.toFixed(2);
    });

    if (!allMaterialsValid) {
      return false;
    }

    // Every selected product batch must have at least one material
    const selectedProductBatchIds = selectedValues;
    return selectedProductBatchIds.every((productBatchId) => {
      return materials.some(
        (material) => material.product_batch_id === productBatchId
      );
    });
  };
  // Handle cloud download icon click
  const handleGenerateLabel = (index) => {
    const list = [...materials];
    const containerCount = parseInt(list[index].mrr_container_count) || 0;

    if (containerCount <= 0) {
      message.error('Please enter number of containers first');
      return;
    }

    // Show container input section
    list[index].showContainerInput = true;

    // Initialize containers array if needed
    if (
      !list[index].returned_containers ||
      list[index].returned_containers.length === 0
    ) {
      list[index].returned_containers = [
        { container_count: '', container_qty: '' }
      ];
    }

    setMaterials(list);
  };

  // Add new container row
  const addContainerRow = (materialIndex) => {
    const list = [...materials];
    const containerCount =
      parseInt(list[materialIndex].mrr_container_count) || 0;
    const currentContainers = list[materialIndex].containers?.length || 0;

    if (currentContainers < containerCount) {
      if (!list[materialIndex].returned_containers) {
        list[materialIndex].returned_containers = [];
      }
      list[materialIndex].returned_containers.push({
        container_count: '',
        container_qty: ''
      });
      setMaterials(list);
    } else {
      message.info('Container count limit reached');
    }
  };

  // Check if all container rows are filled
  const areAllContainersFilled = (materialIndex) => {
    const material = materials[materialIndex];
    const containerCount = parseInt(material.mrr_container_count) || 0;
    const returned_containers = material.returned_containers || [];

    if (
      !material.material_id ||
      !material.returned_qty ||
      containerCount <= 0
    ) {
      return false;
    }

    return (
      returned_containers.length >= containerCount &&
      returned_containers.every((c) => c.container_count && c.container_qty)
    );
  };

  const handlePrintLabel = (id) => {
    const payload = { id };
    setIsLoading(true);
    setPrintingId(id);
    dispatch(printContainerlabel(payload))
      .then((response) => {
        if (response?.payload?.success) {
          window.open(
            `${
              process.env.REACT_APP_STORAGE_URL
            }${response?.payload?.data?.pdf_url.split('/').pop()}`,
            '_blank'
          );
          message.success(response?.payload?.message);
          handleGetMaterialById();
        }
      })
      .finally(() => {
        setIsLoading(false);
        setPrintingId(null);
      });
  };
  const handlePrintReceipt = () => {
    const id = searchParams.get('id');
    if (!id) return;
    setIsLoading(true);
    dispatch(generateMRRReceipt({ id })).then((response) => {
      setIsLoading(false);
      if (response?.payload?.success) {
        window.open(
          `${
            process.env.REACT_APP_STORAGE_URL
          }${response?.payload?.data?.pdf_url.split('/').pop()}`,
          '_blank'
        );
        message.success(response?.payload?.message);
      } else {
        message.error(
          response?.payload?.message || 'Failed to generate receipt.'
        );
      }
    });
  };

  const onFinish = (values) => {
    setTruckShow(false);
    searchParams?.get('id')
      ? (values['id'] = searchParams?.get('id'))
      : searchParams?.get('uuid')
      ? (values['uuid'] = searchParams?.get('uuid'))
      : '';
    values['returned_material_items'] = materials;
    dispatch(createReturnMaterials(values)).then((response) => {
      setTruckShow(false);
      if (response?.payload?.success) {
        message.success(response?.payload?.message);
        searchParams?.get('id')
          ? history.push(`create-return-qty?id=${searchParams?.get('id')}`)
          : history.push(`create-return-qty?uuid=${response?.payload?.data}`);
        setTimeout(() => {
          handleGetMaterialById();
        }, 100);
      } else {
        message.error(
          response?.payload?.message || 'Failed to create return request.'
        );
      }
    });
  };

  // Comments are captured only on the QA approve/reject decision (QA Pending).
  // Once QA has approved, the box is read-only for everyone — the warehouse
  // accepts without adding comments.
  const canEnterComments = () =>
    (user?.role === 'qc_initiator' || user?.role === 'qa_super_user') &&
    status == 'QA Pending';

  const handleApprove = (status) => {
    setTruckShow(true);
    const payload = {
      id: searchParams.get('id') || searchParams.get('uuid'),
      status,
      QA_comments:
        status == 'QA Approved' || status == 'QA Rejected'
          ? comments
          : qAComments,
      WH_comments: status == 'WH Accepted' ? comments : ''
    };
    dispatch(updateStatus(payload)).then((response) => {
      if (response?.payload?.success) {
        setTruckShow(false);
        message.success(response?.payload?.message);
        history.push('/material-return-request');
      }
    });
  };

  const handlecomments = (e) => {
    setComments(e.target.value);
  };

  const handleEditReturn = (index) => {
    const payload = { dispensing_request_id: productId, type: 'edit' };
    dispatch(getAllCodes(payload)).then((response) => {
      if (response?.payload?.success) {
        setCodes(response?.payload?.data);
      }
    });
    const list = [...materials];
    list[index].edit = true;
    setMaterials(list);
  };

  return (
    <Layout sider={false}>
      {qAComments ? (
        <Card>
          <Alert message={qAComments} type="info" showIcon />
        </Card>
      ) : (
        ''
      )}
      {whComments ? (
        <Card>
          <Alert message={whComments} type="info" showIcon />
        </Card>
      ) : (
        ''
      )}
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Card
          title={<span>MATERIAL RETURN QUANTITY</span>}
          className={`${styles.cardStyles_approver}`}
        >
          <Row gutter={24}>
            <Col xs={24} xl={24} span={24} md={24} sm={24}>
              <FormItem
                label="Product Batch (Process › SubProcess)"
                name="dispensing_request_id"
                rules={[
                  {
                    required: true,
                    message: 'Select Product Batch'
                  }
                ]}
                className={styles.customLable}
              >
                {searchParams.get('id') ? (
                  <Input placeholder="Enter Product batch" disabled />
                ) : (
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Select a product batch"
                    optionFilterProp="children"
                    onSearch={onSearch}
                    onChange={handleChangeMaterial}
                    value={selectedValues}
                    disabled={status || searchParams.get('uuid') ? true : false}
                    loading={getAllMaterilLoading}
                    dropdownMatchSelectWidth={false}
                  >
                    {filteredMaterials?.map((item, index) => {
                      const dp =
                        item?.prod_label_process_master?.process_label_name;
                      const dsp =
                        item?.prod_label_sub_process?.sub_process_name;
                      const suffix =
                        dp && dsp ? ` (${dp} › ${dsp})` : dp ? ` (${dp})` : '';
                      return (
                        <option value={item.id} key={index}>
                          {`${item.product_batch_number}${suffix}`}
                        </option>
                      );
                    })}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={8} span={12} md={24} sm={24}>
              <FormItem
                label="Product Name"
                name="product_name"
                rules={[
                  {
                    required: false,
                    message: 'Select Product Name'
                  }
                ]}
                className={styles.customLable}
              >
                <Input placeholder="Enter Product Name" disabled />
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={12} md={24} sm={24}>
              <FormItem
                label="BMR/BPR #"
                name="bmp_bpr_number"
                rules={[
                  {
                    required: false,
                    message: 'Select Product Name'
                  }
                ]}
                className={styles.customLable}
              >
                <Input placeholder="Enter BMR/BPR Number" disabled />
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={12} md={24} sm={24}>
              <FormItem
                label="Date"
                name="returned_date"
                rules={[
                  {
                    required: false,
                    message: 'Select Product Name'
                  }
                ]}
                className={styles.customLable}
              >
                <Input placeholder="Date" disabled />
              </FormItem>
            </Col>
          </Row>
        </Card>
        <br />
        <Card className={`${styles.subpanel}`}>
          {materials?.map((item, index) => {
            const containerCount = parseInt(item.mrr_container_count) || 0;
            const currentContainers = item.returned_containers?.length || 0;
            const allContainersFilled = areAllContainersFilled(index);

            const containers = searchParams?.get('id')
              ? item.returned_containers
              : searchParams?.get('uuid')
              ? item.returned_containers
              : item.returned_containers;
            return (
              <div key={index}>
                <Row gutter={24}>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Material Code"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Material Code'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        onChange={(e) => {
                          const selectedData = JSON.parse(e);
                          handleChange(selectedData, index, 'material_id');
                        }}
                        value={item?.material_code}
                        placeholder="Select Material Code"
                        disabled={
                          searchParams?.get('id') || searchParams?.get('uuid')
                        }
                      >
                        {result?.map((codeItem, idx) => {
                          const value = JSON.stringify({
                            id: codeItem?.materials?.[0]?.id,
                            product_batch_number: codeItem?.product_batch_number
                          });
                          return (
                            <option key={idx} value={value}>
                              {codeItem?.materials?.[0]?.code}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Material Name"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Material Name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Material name"
                        value={item?.material_name}
                        disabled={
                          searchParams?.get('id') || searchParams?.get('uuid')
                        }
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Product batch"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Product batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select product batch"
                        onChange={(e) =>
                          handleChange(e, index, 'product_batch_id')
                        }
                        value={
                          searchParams?.get('id') || searchParams?.get('uuid')
                            ? item?.product_batch_id
                            : item?.product_batch_number
                        }
                        disabled={
                          searchParams?.get('id') || searchParams?.get('uuid')
                        }
                        dropdownMatchSelectWidth={false}
                      >
                        {prodBatches?.[0]?.product_batch_numbers?.map(
                          (item, index) => {
                            return (
                              <option value={item?.dispense_req_id} key={index}>
                                {`${item?.batch_number}${getOperationSuffix(
                                  item?.dispense_req_id
                                )}`}
                              </option>
                            );
                          }
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Inhouse Batch #"
                      rules={[
                        {
                          required: true,
                          message: 'Select Inhouse Batch Number'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Inhouse Batch Number"
                        onChange={(e) =>
                          handleChange(e, index, 'batch_detail_id')
                        }
                        value={item?.inhouse_batch_no}
                        disabled={
                          searchParams?.get('id') || searchParams?.get('uuid')
                        }
                      >
                        {batches
                          // ?.filter(
                          //   (batch) =>
                          //     !materials.some(
                          //       (material) =>
                          //         material.batch_detail_id === batch.id
                          //     )
                          // )
                          ?.map((item, index) => {
                            return (
                              <option value={item?.id} key={index}>
                                {item?.inhouse_batch_number}
                              </option>
                            );
                          })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <FormItem
                      label="Total Qty"
                      rules={[
                        {
                          required: true,
                          message: 'Select Inhouse Batch Number'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        type="number"
                        min="0"
                        max={item?.total_qty}
                        step="any"
                        placeholder="Return Qty"
                        onChange={(e) =>
                          handleChange(e.target.value, index, 'returned_qty')
                        }
                        value={item?.returned_qty}
                        disabled={item?.edit || status == '' ? false : true}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={7} span={12} md={24} sm={24}>
                    <FormItem
                      label="No.of containers"
                      rules={[
                        {
                          required: true,
                          message: 'Enter number of containers'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        type="number"
                        min="0"
                        step="1"
                        placeholder="Containers"
                        onChange={(e) =>
                          handleChange(
                            e.target.value,
                            index,
                            'mrr_container_count'
                          )
                        }
                        value={item?.mrr_container_count}
                        disabled={
                          searchParams?.get('id') || searchParams?.get('uuid')
                        }
                      />
                    </FormItem>
                  </Col>
                  {!searchParams?.get('id') &&
                    !searchParams?.get('uuid') &&
                    materials.length > 1 && (
                      <Col
                        xs={24}
                        xl={1}
                        span={12}
                        md={24}
                        sm={24}
                        style={{ marginTop: '32px' }}
                      >
                        <DeleteOutlined
                          style={{
                            color: '#ff4d4f',
                            cursor: 'pointer',
                            fontSize: '16px'
                          }}
                          onClick={() => removeMaterials(index)}
                        />
                      </Col>
                    )}
                  {(searchParams?.get('id') || searchParams?.get('uuid')) &&
                  user?.role !== 'user' &&
                  user?.role !== 'qc_initiator' ? (
                    status !== 'WH Accepted' ? (
                      (user?.role === 'prod_user' &&
                        status !== 'QA Approved' &&
                        user?.level == 3) ||
                      (status !== 'QA Approved' && user?.level == 2) ||
                      SuperadminProddata?.[0]?.level == 3 ||
                      SuperadminProddata?.[0]?.level == 2 ? (
                        <Col
                          xs={24}
                          xl={1}
                          span={12}
                          md={24}
                          sm={24}
                          style={{ marginTop: '32px' }}
                        >
                          <EditOutlined
                            onClick={() => handleEditReturn(index, item?.id)}
                          />
                        </Col>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                </Row>

                {/* Container rows section */}
                {item.showContainerInput && (
                  <>
                    {containers?.map((container, containerIndex) => (
                      <Row
                        gutter={24}
                        key={containerIndex}
                        style={{ marginTop: '10px' }}
                      >
                        <Col xs={24} xl={6} span={12} md={24} sm={24}>
                          <FormItem
                            label={`Container ${containerIndex + 1}`}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Container"
                              value={
                                container.container_count ||
                                `Container ${
                                  containerIndex + 1
                                } of ${containerCount}`
                              }
                              onChange={(e) =>
                                handleContainerChange(
                                  index,
                                  containerIndex,
                                  'container_count',
                                  e.target.value
                                )
                              }
                              disabled
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={6} span={12} md={24} sm={24}>
                          <FormItem label="Qty" className={styles.customLable}>
                            <Input
                              type="number"
                              min="0"
                              step="any"
                              placeholder="Qty"
                              value={container.container_qty}
                              onChange={(e) =>
                                handleContainerChange(
                                  index,
                                  containerIndex,
                                  'container_qty',
                                  e.target.value,
                                  containerCount
                                )
                              }
                              disabled={
                                item?.edit || status == '' ? false : true
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={2} span={12} md={24} sm={24}>
                          <FormItem label="UOM" className={styles.customLable}>
                            <Input
                              placeholder="UOM"
                              value={item?.uom}
                              disabled={true}
                            />
                          </FormItem>
                        </Col>
                        {(searchParams?.get('id') ||
                          searchParams?.get('uuid')) && (
                          <Col xs={24} xl={2} span={12} md={24} sm={24}>
                            {container?.is_print ? (
                              <CustomButton
                                className={styles.border_button}
                                type="primary"
                                ghost
                                style={{ marginTop: '24px' }}
                                onClick={() =>
                                  handlePrintLabel(container?.mrr_container_id)
                                }
                                loading={
                                  printingId === container?.mrr_container_id
                                }
                                disabled={
                                  printingId === container?.mrr_container_id
                                }
                              >
                                Re-Print
                                <CloudDownloadOutlined />
                              </CustomButton>
                            ) : (
                              <CustomButton
                                className={styles.border_button}
                                type="primary"
                                ghost
                                style={{ marginTop: '24px' }}
                                onClick={() =>
                                  handlePrintLabel(container?.mrr_container_id)
                                }
                                loading={isLoading}
                                disabled={
                                  containerIndex > 0 &&
                                  !item.returned_containers[containerIndex - 1]
                                    ?.is_print
                                  // !container.container_count ||
                                  // !container.container_qty
                                }
                              >
                                <CloudDownloadOutlined />
                              </CustomButton>
                            )}
                          </Col>
                        )}

                        {/* Show plus button only when current container is filled and count not reached */}
                        {
                          // container.container &&
                          !searchParams?.get('id') &&
                            !searchParams?.get('uuid') &&
                            container.container_qty &&
                            containerIndex === currentContainers - 1 &&
                            currentContainers < containerCount && (
                              <Col xs={24} xl={2} span={12} md={24} sm={24}>
                                <CustomButton
                                  className={styles.border_button}
                                  type="primary"
                                  ghost
                                  style={{ marginTop: '24px' }}
                                  onClick={() => addContainerRow(index)}
                                >
                                  <PlusCircleOutlined />
                                </CustomButton>
                              </Col>
                            )
                        }
                      </Row>
                    ))}
                  </>
                )}

                {/* Initial cloud download button to start container input */}
                {!searchParams?.get('uuid') &&
                  !item.showContainerInput &&
                  item.mrr_container_count && (
                    // <Row gutter={24} style={{ marginTop: '10px' }}>
                    //   <Col xs={24} xl={2} span={12} md={24} sm={24}>
                    <FormItem className="text-right">
                      <CustomButton
                        className={styles.border_button}
                        type="primary"
                        ghost
                        onClick={() => handleGenerateLabel(index)}
                      >
                        <CloudDownloadOutlined /> Generate Labels
                      </CustomButton>
                    </FormItem>
                    //</div></Col>
                    // </Row>
                  )}

                {/* Show plus button for adding new material when all containers are filled */}
                {!searchParams?.get('uuid') &&
                  !searchParams?.get('id') &&
                  allContainersFilled &&
                  index === materials.length - 1 && (
                    // <Row gutter={24} style={{ marginTop: '10px' }}>
                    //   <Col xs={24} xl={2} span={12} md={24} sm={24}>
                    <FormItem className="text-right">
                      <CustomButton
                        className={styles.border_button}
                        type="primary"
                        ghost
                        onClick={() => addMaterials()}
                      >
                        <PlusCircleOutlined /> Add Material
                      </CustomButton>
                    </FormItem>
                    //</Col>
                    //</Row>
                  )}

                <hr style={{ margin: '20px 0', border: '1px solid #f0f0f0' }} />
              </div>
            );
          })}

          {user?.role !== 'prod_user' && (
            <Col xs={24} xl={22} span={12} md={24} sm={24}>
              <FormItem
                label="Comments"
                rules={[
                  {
                    required: true,
                    message: 'Enter Comments'
                  }
                ]}
                className={styles.customLable}
              >
                <TextArea
                  rows={4}
                  placeholder="Comments"
                  onChange={(e) => handlecomments(e)}
                  disabled={!canEnterComments()}
                />
              </FormItem>
            </Col>
          )}

          <FormItem className="text-center">
            <Space>
              <CustomButton
                type="primary"
                onClick={() => history.push('/material-return-request')}
                loading={loading}
                ghost
              >
                Back
              </CustomButton>
              {searchParams?.get('id') && status === 'QA Approved' && (
                <CustomButton
                  type="primary"
                  onClick={handlePrintReceipt}
                  loading={isLoading}
                >
                  <PrinterOutlined /> Print MRR Report
                </CustomButton>
              )}
              {truckShow ? (
                <Image
                  src={truck}
                  preview={false}
                  style={{ width: '100px !important', height: '100px' }}
                />
              ) : (user?.role === 'qc_initiator' ||
                  user?.role === 'qa_super_user') &&
                status == 'QA Pending' ? (
                <Space>
                  <CustomButton
                    type="primary"
                    loading={loading}
                    onClick={() => handleApprove('QA Approved')}
                    style={{
                      backgroundColor: '#28a745',
                      borderColor: '#28a745'
                    }}
                  >
                    Approve
                  </CustomButton>
                  <CustomButton
                    type="primary"
                    loading={loading}
                    onClick={() => handleApprove('QA Rejected')}
                    style={{
                      backgroundColor: '#dc3545',
                      borderColor: '#dc3545'
                    }}
                  >
                    Reject
                  </CustomButton>
                </Space>
              ) : (user?.role === 'user' || user?.role === 'qa_super_user') &&
                status == 'QA Approved' ? (
                <Space>
                  <CustomButton
                    type="primary"
                    loading={loading}
                    onClick={() => handleApprove('WH Accepted')}
                    style={{
                      backgroundColor: '#28a745',
                      borderColor: '#28a745'
                    }}
                  >
                    Accept
                  </CustomButton>
                </Space>
              ) : !searchParams?.get('id') &&
                !searchParams?.get('uuid') &&
                (user?.role === 'prod_user' ||
                  user?.role === 'qa_super_user') &&
                status == '' ? (
                <CustomButton
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={!canEnableCreateButton()}
                >
                  Create
                </CustomButton>
              ) : (
                ''
              )}
              {searchParams?.get('id') || searchParams?.get('uuid') ? (
                (user?.role === 'prod_user' &&
                  (user?.level == '3' || user?.level == '2') &&
                  status !== 'QA Approved') ||
                SuperadminProddata?.[0]?.level == 3 ? (
                  truckShow ? (
                    <Image
                      src={truck}
                      preview={false}
                      style={{ width: '100px !important', height: '100px' }}
                    />
                  ) : (
                    status !== 'WH Accepted' && (
                      <CustomButton
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={!canEnableUpdateButton()}
                      >
                        Update
                      </CustomButton>
                    )
                  )
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </Space>
          </FormItem>
        </Card>
      </Form>
    </Layout>
  );
};
export default CreateReturnQty;
